module.exports = __webpack_public_path__ + "img/price-banner-sm.c0703758.jpg";